import React from 'react';
import PropTypes from 'prop-types';

import AttributeRow from './attribute_row';

import { Row, Col } from 'react-bootstrap';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export class CompReportAttributeSelector extends React.Component {
  static propTypes = {
    attributeOptions: PropTypes.array.isRequired,
    selectedAttributes: PropTypes.array.isRequired,
    onAttributeRemove: PropTypes.func.isRequired,
    onAttributesClear: PropTypes.func.isRequired,
    onAttributeSelect: PropTypes.func.isRequired,
    onReorder: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { value: '' };
  }

  selectableAttributes = () => {
    const { attributeOptions, selectedAttributes } = this.props;

    const attributes = attributeOptions.filter(
      a => !selectedAttributes.includes(a['key'])
    );
    const filteredAttributes = this.state.value
      ? attributes.filter((a) => {
        return a['label']
          .toLowerCase()
          .includes(this.state.value.toLowerCase());
      })
      : attributes;
    // display in alphabetical order
    filteredAttributes.sort((a, b) => {
      return a['label'] < b['label'] ? -1 : a['label'] > b['label'] ? 1 : 0;
    });

    return filteredAttributes;
  };

  selectedAttributes = () => {
    const { attributeOptions, selectedAttributes } = this.props;

    return selectedAttributes.map((selectedAttribute) => {
      return attributeOptions.find(a => a.key === selectedAttribute);
    });
  };

  onSearch = (e) => {
    this.setState({
      value: e.target.value
    });
  };

  renderAttributeRow = (option) => {
    const onClick = () => {
      this.setState({ value: '' });
      this.props.onAttributeSelect(option);
    };
    return (
      <li
        className="p-3 clickable"
        key={option.key}
        name="attributeRow"
        onClick={onClick}
      >
        {option['label']}
      </li>
    );
  };

  renderSelectedAttributeRow = (option, index) => {
    const { onAttributeRemove, onReorder } = this.props;

    return (
      <AttributeRow
        index={index}
        key={option.key}
        option={option}
        onRemoveAttribute={onAttributeRemove}
        onReorder={onReorder}
      />
    );
  };

  renderAvailableFields() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">Available Fields</div>
        <div className="panel-body">
          <div className="border-bottom">
            <input
              aria-label="search field options by substring"
              className="form-control"
              placeholder="Search Fields"
              type="text"
              value={this.state.value}
              onChange={this.onSearch}
            />
          </div>
          <ul>{this.selectableAttributes().map(this.renderAttributeRow)}</ul>
        </div>
      </div>
    );
  }

  renderSelectedFields() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          Selected Fields
          <span
            className="pull-right clickable"
            name="clearAttributesLink"
            onClick={this.props.onAttributesClear}
          >
            Clear All
          </span>
        </div>
        <div className="panel-body">
          <ul>
            {this.selectedAttributes().map(this.renderSelectedAttributeRow)}
          </ul>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Row className="item-selector">
        <Col xs={6}>{this.renderAvailableFields()}</Col>
        <Col xs={6}>{this.renderSelectedFields()}</Col>
      </Row>
    );
  }
}

export default reorderableList(CompReportAttributeSelector);
